import styled, { keyframes } from "styled-components";

//image should go here in background
export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    background: url(${props => props.background});
    transition: transform 1.2s ease,opacity .25s ease,-webkit-transform 1.2s ease,-moz-transform 1.2s ease,-o-transform 1.2s ease;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const TextWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-image: radial-gradient(ellipse at center,rgba(26, 30, 31, 0.4) 0,#0D0E12 95%);
`;

export const IUWrapper = styled.div`
    height: calc((100vh + 160px) - 248px);
    display: flex;
    align-items: center;
`;

export const Text = styled.div`
    padding: 2rem;
    background: transparent;
    height: fit-content;
    font-size: 48pt;
    font-weight: 700;
    line-height: .85em;
    text-transform: uppercase;
    display: inline-block;
    max-width: 600px;
    padding: 40px 20px;
    overflow: hidden;
    margin: auto;
    text-align: center;
    color: #fff;
    background:
      linear-gradient(to right, white 4px, transparent 4px) 0 0,
      linear-gradient(to right, white 4px, transparent 4px) 0 100%,
      linear-gradient(to left, white 4px, transparent 4px) 100% 0,
      linear-gradient(to left, white 4px, transparent 4px) 100% 100%,
      linear-gradient(to bottom, white 4px, transparent 4px) 0 0,
      linear-gradient(to bottom, white 4px, transparent 4px) 100% 0,
      linear-gradient(to top, white 4px, transparent 4px) 0 100%,
      linear-gradient(to top, white 4px, transparent 4px) 100% 100%;
  
    background-repeat: no-repeat;
    background-size: 20px 20px;

    @media (max-width: 900px){
        max-width: 80%;
        font-size: 36pt;
    }
`;

export const SubText = styled.p`
    font-size: 16pt;
    font-weight: 700;
    margin: 14px 0 0 0;
    text-transform: uppercase;
`;
//background for hover 
//background-image: radial-gradient(center,ellipse cover,rgba(24,30,45,.3) 0,#181e2d 130%)

export const ScrollDown = styled.div`
    position: absolute;
    bottom: 50px;
    left:0;
    right:0;
    margin: auto;

    width :34px;
    height: 55px;
`;

export const Mouse = styled.div`
    width: 3px;
    padding: 10px 15px;
    height: 35px;
    border: 2px solid #fff;
    border-radius: 25px;
    opacity: 0.75;
    box-sizing: content-box;
`;

export const Scroll = keyframes`
    0% { opacity: 0; }
    10% { transform: translateY(0); opacity: 1; }
    100% { transform: translateY(15px); opacity: 0;}
`;

export const Scroller = styled.div`
    width: 3px;
    height: 10px;
    border-radius: 25%;
    background-color: #fff;
    animation-name: ${Scroll};
    animation-duration: 2.2s;
    animation-timing-function: cubic-bezier(.15,.41,.69,.94);
    animation-iteration-count: infinite;
`;

